// Mock data for Capital Food - Cloud Kitchen Platform

import { Product } from "../Model/product";

export interface Restaurant {
  id: number;
  name: string;
  tagline: string;
  image: string;
  logo: string;
  rating: number;
  deliveryTime: string;
  offer: string;
  cuisine: string;
  priceRange: string;
  isOn: boolean;
}

export interface MenuItem {
  id: number;
  name: string;
  description: string;
  price: number;
  image: string;
  veg: boolean;
  bestseller?: boolean;
}

export interface Offer {
  id: number;
  title: string;
  subtitle?: string;
  price?: string;
  extra?: string;
  bgColor: string;
  textColor: string;
  border?: boolean;
}

// export interface CartItem extends MenuItem {
//   quantity: number;
//   restaurantId: number;


//   restaurantName: string;
// }

export interface CartItem extends Product {
  quantity: number;
  restaurantId: number;
  restaurantName: string;
}

export const restaurants: Restaurant[] = [
  {
     id: null,
    name: "Regal Biryani",
    tagline: "Treasure of Hyderabadi Biryanis",
    image: "assets/img/regalBiryani.webp",
    logo: "assets/img/regalBiryaniLogo.webp",
    rating: 4.7,
    deliveryTime: "20-30 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Biryani",
    priceRange: "₹₹",
    isOn: true
  },
  {
    id: null,
    name: "Deccan Spice",
    tagline: "Bengaluru Style Signature Biryanis",
    image: "assets/img/deccanSpiceBirayani.webp",
    logo:"assets/img/DeccanSpiceLogo.webp",
    rating: 4.6,
    deliveryTime: "15-25 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Biryani",
    priceRange: "₹₹",
     isOn: true
  },
  {
   id: null,
    name: "Mount Momo",
    tagline: "Signature Momos of the Mountains",
    image:"assets/img/Mountmomo.webp",
    logo: "assets/img/MountmomoLogo.webp",
    rating: 4.8,
    deliveryTime: "15-25 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Momo",
    priceRange: "₹₹",
    isOn: false
  },
  {
    id: null,
    name: "Cooper",
    tagline: "Craft Burgers, Elevated. Redefined Flavor Mastery",
    image:"assets/img/Cooperimg.webp",
    logo: "assets/img/Cooperlogo.webp",
    rating: 4.6,
    deliveryTime: "25-35 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Burger",
    priceRange: "₹₹",
    isOn: false
  },
  {
    id: null,
    name: "The Cake House",
    tagline: "Cakes for unforgettable moments",
    image: "assets/img/The Cake House.webp",
    logo: "assets/img/cakeHouseLogo.webp",
    rating: 4.5,
    deliveryTime: "15-25 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Cakes",
    priceRange: "₹",
    isOn: false
  },
  // "assets/img/piza.webp",
  // https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=800&q=80
  
  {
    id: null,
    name: "Tetos",
    tagline: "Premium pizzas with lavish toppings",
    image: "assets/img/Tetos.webp",
    logo: "assets/img/TetosLogo.webp",
    rating: 4.7,
    deliveryTime: "25-35 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Pizza",
    priceRange: "₹₹₹",
    isOn: false
  },
  {
    id: null,
    name: "The Gravy Train",
    tagline: "Your Curry Destination!",
    image: "assets/img/gravyTrain.webp",
    logo:"assets/img/gravyTrainLogo.webp",
    rating: 4.4,
    deliveryTime: "15-25 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Curries",
    priceRange: "₹₹",
    isOn: false
  },
  {
    id: null,
    name: "Kavery",
    tagline: "Gateway to South India's culinary trail!",
    image:"assets/img/Kavery.webp",
    logo: "assets/img/kaveryLogo.webp",
    rating: 4.8,
    deliveryTime: "30-40 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "South Indian",
    priceRange: "₹₹₹",
    isOn: false
  },
  {
    id: null,
    name: "Canton Flair",
    tagline: "Savor the taste of China",
    image: "assets/img/cantonFlair.webp",
    logo: "assets/img/cantonFlairLogo.webp",
    rating: 4.9,
    deliveryTime: "30-40 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Chinese",
    priceRange: "₹₹₹",
    isOn: false
  },
  {
    id: null,
    name: "SWAD Uttar",
    tagline: "Bold flavors and aromas of North India's culinary gem!",
    image:"assets/img/swaddUttar.webp",
    logo:"assets/img/SwaadLogo.webp",
    rating: 4.9,
    deliveryTime: "20-30 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Punjabi",
    priceRange: "₹₹",
    isOn: false
  },
  {
    id: null,
    name: "Fast Bites",
    tagline: "Street food, the Indian way!",
    image: "assets/img/FastBite.webp",
    logo: "assets/img/fastBitesLogo.webp",
    rating: 4.5,
    deliveryTime: "20-30 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Street Food",
    priceRange: "₹₹",
    isOn: false
  },
  {
    id: null,
    name: "Cheesy Panda",
    tagline: "Overload your senses, indulge in the cheesy goodness",
    image: "assets/img/Cheesy Panda.webp",
    logo: "assets/img/chessyPanndaLogo.webp",
    rating: 4.7,
    deliveryTime: "15-25 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Cheese Cakes",
    priceRange: "₹",
    isOn: false
  },
  {
    id: null,
    name: "Sandwich Club",
    tagline: "Protein-packed, pocket-friendly Subs",
    image:"assets/img/sandWitchClub.webp",
    logo: "assets/img/sandwitchlogo.webp",
    rating: 4.6,
    deliveryTime: "20-30 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "SandWich",
    priceRange: "₹₹",
    isOn: false
  },
  {
    id: null,
    name: "Ho Puffs",
    tagline: "Puff pastries that'll puff up your day!",
    image: "assets/img/Ho Puffs.webp",
    logo: "assets/img/hoPuffsLogo.webp",
    rating: 4.8,
    deliveryTime: "15-25 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "Puff Pastries",
    priceRange: "₹₹",
    isOn: false
  },
  {
    id: null,
    name: "Urban Bowl",
    tagline: "Global cuisines converge in a single, satisfying serving.",
    image: "assets/img/Urban Bowl.webp",
    logo: "assets/img/UrbanBowlLogo.webp",
    rating: 4.8,
    deliveryTime: "25-35 min",
    offer: "Bulk Order : Prebook & Save 50%",
    cuisine: "World Cuisine",
    priceRange: "₹₹",
    isOn: false
  }
];

export const offers: Offer[] = [
  // {
  //   id: 1,
  //   title: "Family Saver",
  //   subtitle: "10% Discount",
  //   bgColor: "bg-slate-900",
  //   textColor: "text-white"
  // },
  // {
  //   id: 2,
  //   title: "BIRYANI",
  //   price: "₹116",
  //   bgColor: "bg-white",
  //   textColor: "text-emerald-600",
  //   border: true
  // },
  // {
  //   id: 3,
  //   title: "VALUE FUN",
  //   subtitle: "PIZZAS",
  //   price: "₹99",
  //   bgColor: "bg-white",
  //   textColor: "text-orange-500",
  //   border: true
  // },
  // {
  //   id: 4,
  //   title: "GUILT",
  //   subtitle: "FREE",
  //   bgColor: "bg-white",
  //   textColor: "text-green-600",
  //   border: true
  // },
  // {
  //   id: 5,
  //   title: "FLAT",
  //   price: "₹99",
  //   bgColor: "bg-emerald-500",
  //   textColor: "text-white"
  // },
  // {
  //   id: 6,
  //   title: "WHAT'S",
  //   subtitle: "NEW",
  //   bgColor: "bg-gray-100",
  //   textColor: "text-emerald-600"
  // },
  // {
  //   id: 7,
  //   title: "BUY ONE",
  //   subtitle: "GET ONE",
  //   extra: "WEDNESDAY",
  //   bgColor: "bg-amber-100",
  //   textColor: "text-amber-800"
  // }
];

export const menuItems: { [key: number]: MenuItem[] } = {
  1: [
    { id: 101, name: "Classic Chicken Burger", description: "100% chicken patty with special sauce", price: 249, image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400&q=80", veg: false, bestseller: true },
    { id: 102, name: "Chicken Zinger", description: "Crispy fried chicken burger", price: 199, image: "https://images.unsplash.com/photo-1606755962773-d324e0a13086?w=400&q=80", veg: false, bestseller: true },
    { id: 103, name: "Veggie Supreme", description: "Grilled vegetable patty", price: 179, image: "https://images.unsplash.com/photo-1550547660-d9450f859349?w=400&q=80", veg: true },
    { id: 104, name: "Double Decker", description: "Double patty, double cheese", price: 349, image: "https://images.unsplash.com/photo-1594212699903-ec8a3eca50f5?w=400&q=80", veg: false },
    { id: 105, name: "Mushroom Swiss", description: "Sautéed mushrooms & Swiss cheese", price: 279, image: "https://images.unsplash.com/photo-1572802419224-296b0aeee0d9?w=400&q=80", veg: true }
  ],
  2: [
    { id: 201, name: "Margherita Pizza", description: "Classic tomato, mozzarella & basil", price: 299, image: "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=400&q=80", veg: true, bestseller: true },
    { id: 202, name: "Pepperoni Supreme", description: "Loaded pepperoni with cheese", price: 449, image: "https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400&q=80", veg: false, bestseller: true },
    { id: 203, name: "BBQ Chicken", description: "Smoky BBQ sauce with grilled chicken", price: 399, image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&q=80", veg: false },
    { id: 204, name: "Veggie Delight", description: "Fresh vegetables on herb crust", price: 349, image: "https://images.unsplash.com/photo-1571407970349-bc81e7e96d47?w=400&q=80", veg: true },
    { id: 205, name: "Four Cheese", description: "Mozzarella, cheddar, parmesan & gouda", price: 429, image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400&q=80", veg: true, bestseller: true },
    { id: 206, name: "Mushroom Truffle", description: "Wild mushrooms with truffle oil", price: 479, image: "https://images.unsplash.com/photo-1604382355076-af4b0eb60143?w=400&q=80", veg: true }
  ],
  3: [
    { id: 301, name: "Hyderabadi Chicken Biryani", description: "Dum-cooked with aromatic spices", price: 299, image: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=400&q=80", veg: false, bestseller: true },
    { id: 302, name: "Mutton Biryani", description: "Tender mutton in fragrant rice", price: 399, image: "https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=400&q=80", veg: false, bestseller: true },
    { id: 303, name: "Veg Dum Biryani", description: "Garden fresh vegetables", price: 249, image: "https://images.unsplash.com/photo-1631515243349-e0cb75fb8d3a?w=400&q=80", veg: true },
    { id: 304, name: "Paneer Biryani", description: "Cottage cheese biryani", price: 279, image: "https://images.unsplash.com/photo-1633945274405-b6c8069047b0?w=400&q=80", veg: true },
    { id: 305, name: "Egg Biryani", description: "Eggs in spiced rice", price: 229, image: "https://images.unsplash.com/photo-1642821373181-696a54913e93?w=400&q=80", veg: false }
  ],
};

export const cities: string[] = [
  "Bhubaneswar",
   "Cuttack",
   "Khordha",
   "jatni"
];

export const companyInfo = {
  name: "Capital Food",
  tagline: "14 Restaurants, One Platform - Unlimited Savings!",
  description: "capitalfood.in is a culinary ecosystem where multiple brands converge, orchestrating a symphony of flavors and cuisines under one digital roof. We redefine convenience, empowering customers to curate their food experience, accessing a universe of delights across diverse brands and cuisines.",
  mission: "A platform that takes you straight to a no-nonsense, curated selection of restaurants. Get unlimited savings with 30% OFF every time on all restaurants and NO extra charges on delivery, packaging or surge.",
  motto: "Order now and make every meal a celebration!"
};